import { useTranslation } from "react-i18next";

import articleDeliveryTypes from "astrid-firestore/src/api/articles/constants/articleDeliveryTypes";
import articleStatuses from "astrid-firestore/src/api/articles/constants/articleStatuses";

import Flex from "../../../../components/Flex/Flex";

import useArticleDeliveryStatus from "../../hooks/useArticleDeliveryStatus";

import ArticleDeliveryStatusLabel from "./ArticleDeliveryStatusLabel";

export default function ArticleDeliveryStatus({ article, channel, onClick }) {
	const { t } = useTranslation();

	const artifactStatus = useArticleDeliveryStatus("artifact", { article, channel });
	const metadataStatus = useArticleDeliveryStatus("metadata", { article, channel });
	const deliveryTypes = article?.channels?.[channel?.id]?.deliveryTypes;
	const artifactDisabled = deliveryTypes && !deliveryTypes.includes(articleDeliveryTypes.ARTIFACT);
	const metadataDisabled = deliveryTypes && !deliveryTypes.includes(articleDeliveryTypes.METADATA);

	if (article.status === articleStatuses.DRAFT) {
		return <ArticleDeliveryStatusLabel text={t("draft", "Draft")} />;
	}

	if (channel && !article.channelIds?.includes(channel?.id)) {
		return (
			<Flex justifyContent="flex-end">
				<ArticleDeliveryStatusLabel disabled text={t("disabled", "Disabled")} />
			</Flex>
		);
	}

	return (
		<Flex gap={10} style={{ flex: 0 }}>
			{metadataDisabled ? (
				<ArticleDeliveryStatusLabel disabled status={t("disabled", "Disabled")} text={t("meta", "Meta")} />
			) : (
				<ArticleDeliveryStatusLabel
					text={t("meta", "Meta")}
					style={{ cursor: onClick && "pointer" }}
					onClick={onClick && ((e) => onClick(e, { type: articleDeliveryTypes.METADATA }))}
					{...metadataStatus}
				/>
			)}
			{artifactDisabled ? (
				<ArticleDeliveryStatusLabel disabled status={t("disabled", "Disabled")} text={t("files", "Files")} />
			) : (
				<ArticleDeliveryStatusLabel
					text={t("files", "Files")}
					style={{ cursor: onClick && "pointer" }}
					onClick={onClick && ((e) => onClick(e, { type: articleDeliveryTypes.ARTIFACT }))}
					{...artifactStatus}
				/>
			)}
		</Flex>
	);
}
